var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('button',{staticClass:"primary top-0 bottom-20 fw-600",on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }